<div class="kx-cstm-modal-container">
  <div class="modal-header kx-cstm-modal-header p-0">
    <div class="kx-cstm-popup-title">
      @if (status==true) {
        <h5>Success !</h5>
      }
      @if (status==false) {
        <h5>Fail !</h5>
      }
    </div>
  </div>
  <!-- <div class="modal-body kx-cstm-popup-body"> -->
  <ng-container>
    <b class="text-center" align="center">
      @if (status) {
        <i class="fa fa-check-circle text-success" aria-hidden="true"></i>
        } @if (!status) {
        <i
        class="fa fa-times-circle-o text-danger" aria-hidden="true"></i>
        } Your payment for
        @if (!data.txnId && !data.admissionId) {
          order id
        }
        @if (data.txnId) {
          transaction no
        }
        {{data.orderId}} @if (data.admissionId) {
        Admission Id {{data.admissionId}}
      }
      @if (data.txnId) {
        and transaction id {{data.txnId}}
        } @if (data.amount) {
        and amount {{data.amount}}
        } has been
        @if (status) {
          <span>Successful</span>
          }@if (!status) {
          <span>Failed</span>
        }
      </b>
      <div class="mt-3" align="center">
        <a (click)="Orders()" class="text-color">Return to Orders</a>
      </div>
      @if (data.showReciept) {
        <div class="m-3" align="center">
          <a (click)="printReciept()" class="text-color">Print Reciept</a>
        </div>
      }
    </ng-container>
  <!-- </div> -->
</div>